'use strict';

var addSparweltTeaser = function( $container ){
	var sparweltURL = "https://gutscheine.n-tv.de/widget/index/raw"	
	$.get( sparweltURL, function( data ) {
      var $wrapper = $('.sparwelt__wrapper', $container);
      $container.append(sparweltTemplate(data, 3));
      sparweltAnimation();		
	});

};

var sparweltTemplate = function(data, rowLength){
	var template = '<span class="sparwelt__title" > Gutscheine </span>';
	template += '<div class="sparwelt__angebot">Anzeige / Ein Service von <a href="https://gutscheine.n-tv.de/internal/impressum" target="_blank"><img class="sparwelt__logo" src="' + resourceBaseUrl + '/adaptive/images/sparwelt/sw_logo_new.svg" alt=""></a></div>';
    template += '<div class="sparwelt__wrapper__wrapper">'
	template += '<div class="sparwelt__wrapper">';
	template += '<div class="sparwelt__row">';

	$.each(data, function( index, value ) {

    var imgWidth = getBreakpoint()=='sm' || getBreakpoint()=='md'?60:90;

    if(value.url && value.logo && value.title && value.image){

      template += '<a class="sparwelt__teaser-neu" target="_blank" href="' + value.url + '" target="_blank">';
      template +=		'<div class ="sparwelt__info">';
      template +=			'<img src="' + value.logo + '?w=' + imgWidth + '" alt="" />';
      template +=			'<span class="teaser__kicker">' + value.title + '</span>';
      template +=		'</div>';
      template +=		'<div class="sparwelt__img" style="background-image: url(' + value.image + ');"></div>';
      template +=	'</a>';

      }

		if((index + 1)%rowLength == 0 && index + 1 < data.length ){
			template += '</div><div class="sparwelt__row">';
		}
	});

	template += '</div>';
	template += '</div>';
    template += '</div>';
	template += '<a class="button button--secondary" href="https://gutscheine.n-tv.de" target="_blank">Weitere Gutscheine anzeigen</a>';
	return template;
};

var sparweltAnimation = function () {
	var counter = 1;
	if(getBreakpoint()!="xs"){
		setInterval(function(){
			if(counter >= $('.sparwelt__row').length){
				$('.sparwelt__wrapper').animate({
					left: 0
				});
				counter = 1;
			}
			else{
				$('.sparwelt__wrapper').animate({
					left: -$('.sparwelt__wrapper').width()
				});
				counter++;
			}
		}, 5000);
	}
	$(window).on("resize", function(){
		$('.sparwelt__teaser-neu').css({
			width : $('.sparwelt-neu').width() - 5
		});
		$('.sparwelt__wrapper').css({
			left: 0
		});
	});
	$('.sparwelt__teaser-neu').css({
		width : $('.sparwelt-neu').width() - 5
	});

};

